import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreTextField } from 'src/components/core'

const HeaderSettingsDescription = ({
  classes,
  descriptionValue,
  onThemeSettingsChange,
}) => {
  // Handle description change
  const handleDescriptionChange = event => {
    const value = event.target.value.slice(0, 200)
    onThemeSettingsChange('description', value)
  }

  return (
    <div className={classes.imageContent}>
      <CoreTextField
        multiline
        rows={4}
        label="Header description"
        placeholder="Enter your header description"
        value={descriptionValue}
        onChange={handleDescriptionChange}
        maxLength={200}
        fullWidth
      />
      <div className={classes.imageContent}>
        <Typography className={classes.imageText}>
          Keep it clear and engaging. 200 characters shown.
        </Typography>
      </div>
    </div>
  )
}

export default withStyles(styles)(HeaderSettingsDescription)
